import { Component, OnInit, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IconNames } from '@shared/enums/icon-names';
import { IceButtonComponent } from '@app/shared/components/atoms/ice-button/ice-button.component';
import { MatIcon } from '@angular/material/icon';

enum ImeiApprovalType {
  Unknown,
  Approved,
  Unapproved,
}

@Component({
  selector: 'app-verify-existing-mobile',
  templateUrl: './verify-existing-mobile.component.html',
  styleUrls: ['./verify-existing-mobile.component.scss'],
  imports: [MatIcon, IceButtonComponent],
})
export class VerifyExistingMobileComponent implements OnInit {
  dialogRef = inject<MatDialogRef<VerifyExistingMobileComponent>>(MatDialogRef);
  private data = inject(MAT_DIALOG_DATA);

  IconNames = IconNames;
  ImeiApprovalType = ImeiApprovalType;

  imeiApproval = ImeiApprovalType.Unknown;
  imei: string;

  ngOnInit() {
    this.imei = this.data;
  }

  approveAndNavigateToPhoneSelection() {
    this.imeiApproval = ImeiApprovalType.Approved;
    this.close(true);
  }

  close(value: boolean) {
    this.dialogRef.close(value);
  }
}
